import { render, staticRenderFns } from "./PreliminaryInputQuestion.vue?vue&type=template&id=5b944a88&scoped=true&"
import script from "./PreliminaryInputQuestion.vue?vue&type=script&lang=js&"
export * from "./PreliminaryInputQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b944a88",
  null
  
)

export default component.exports